import { eTipoPermissao } from '@/enums/ePermissoes';
import { eModeloDeclaracao } from '@/enums/eDeclaracao';

/*
 * DECLARAÇÕES DA SECRETARIA — migração de `EmissaoDeclaracao.aspx` e `GrantiaVaga.aspx`.
 *
 * UMA tela e UMA rota por modelo. A tela é a mesma porque o formulário é o mesmo; as rotas são
 * várias porque o menu do legado abre a tela nova por `/proxylegado/<nome>` e a QUERY STRING NÃO
 * ATRAVESSA — um `?tipo=N` chegaria vazio do outro lado. O modelo vai em `meta.modeloDeclaracao`,
 * que é o único lugar de onde a tela pode lê-lo com segurança.
 *
 * As PERMISSÕES são as do LEGADO, a pedido: a estrutura de menus e as permissões próprias das
 * telas novas serão desenhadas à mão depois. Quando isso acontecer, o que muda aqui é só o
 * `meta.permissions` de cada rota — a tela não sabe nada sobre permissão além do que o
 * `BarraBotoes`/`usePermissaoTela` lê da rota.
 *
 * O ATESTADO e a NEGATIVA DE VAGA não têm item no menu do legado (`GrantiaVaga.aspx` não é
 * referenciada em `BLL/Menu`), então ficam provisoriamente com a permissão de Previsão de Vagas,
 * que é a do mesmo grupo. É um dos pontos a revisar no desenho definitivo.
 */
export default [
  {
    description: 'Declaração de Escolaridade',
    path: '/academico/declaracao/escolaridade',
    name: 'declaracao_escolaridade',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOESCOLARIDADENOVO_MENU_300700411],
      modeloDeclaracao: eModeloDeclaracao.Escolaridade,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Escolaridade por Turma',
    path: '/academico/declaracao/escolaridade-turma',
    name: 'declaracao_escolaridade_turma',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOESCOLARIDADEPORTURMANOVO_MENU_300700412],
      modeloDeclaracao: eModeloDeclaracao.EscolaridadePorTurma,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Conclusão',
    path: '/academico/declaracao/conclusao',
    name: 'declaracao_conclusao',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOCONCLUSAONOVO_MENU_300700413],
      modeloDeclaracao: eModeloDeclaracao.Conclusao,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Conclusão por Turma',
    path: '/academico/declaracao/conclusao-turma',
    name: 'declaracao_conclusao_turma',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOCONCLUSAOPORTURMANOVO_MENU_300700414],
      modeloDeclaracao: eModeloDeclaracao.ConclusaoPorTurma,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Transferência',
    path: '/academico/declaracao/transferencia',
    name: 'declaracao_transferencia',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOTRANSFERENCIANOVO_MENU_300700415],
      modeloDeclaracao: eModeloDeclaracao.Transferencia,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Frequência',
    path: '/academico/declaracao/frequencia',
    name: 'declaracao_frequencia',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOFREQUENCIANOVO_MENU_300700416],
      modeloDeclaracao: eModeloDeclaracao.Frequencia,
    },
    goesToMenu: true,
  },
  {
    description: 'Atestado de Frequência (Bolsa Família)',
    path: '/academico/declaracao/frequencia-bolsa-familia',
    name: 'declaracao_frequencia_bolsa_familia',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      // Modelo NOVO, sem item no legado: tem o item próprio da árvore nova de declarações.
      permissions: [eTipoPermissao.ATESTADOFREQUENCIABOLSAFAMILIANOVO_MENU_300700417],
      modeloDeclaracao: eModeloDeclaracao.FrequenciaBolsaFamilia,
    },
    goesToMenu: true,
  },
  {
    description: 'Requerimento de Transferência',
    path: '/academico/declaracao/requerimento-transferencia',
    name: 'declaracao_requerimento_transferencia',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REQUERIMENTODETRANSFERENCIANOVO_MENU_300700418],
      modeloDeclaracao: eModeloDeclaracao.RequerimentoTransferencia,
    },
    goesToMenu: true,
  },
  {
    description: 'Atestado de Vaga',
    path: '/academico/declaracao/atestado-vaga',
    name: 'declaracao_atestado_vaga',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ATESTADODEVAGANOVO_MENU_300700419],
      modeloDeclaracao: eModeloDeclaracao.AtestadoVaga,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração Personalizada',
    path: '/academico/declaracao/personalizada',
    name: 'declaracao_personalizada',
    component: () => import('@/views/academico/declaracao/PersonalizadaEmissao.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAOPERSONALIZADANOVO_MENU_300700427],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Declarações Personalizadas',
    path: '/academico/declaracao/personalizada/cadastro',
    name: 'declaracao_personalizada_cadastro',
    component: () => import('@/views/academico/declaracao/PersonalizadaCadastro.vue'),
    meta: {
      permissions: [eTipoPermissao.CADASTRODECLARACAOPERSONALIZADANOVO_MENU_300700428],
    },
    goesToMenu: true,
  },
  {
    description: 'Log de Atestados e Negativas de Vaga',
    path: '/academico/declaracao/log-vagas',
    name: 'declaracao_log_vagas',
    component: () => import('@/views/academico/declaracao/LogVagas.vue'),
    meta: {
      permissions: [eTipoPermissao.LOGATESTADOSENEGATIVASDEVAGANOVO_MENU_300700429],
    },
    goesToMenu: true,
  },
  {
    description: 'Negativa de Vaga',
    path: '/academico/declaracao/negativa-vaga',
    name: 'declaracao_negativa_vaga',
    component: () => import('@/views/academico/declaracao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.NEGATIVADEVAGANOVO_MENU_300700420],
      modeloDeclaracao: eModeloDeclaracao.NegativaVaga,
    },
    goesToMenu: true,
  },
];
